import { render, staticRenderFns } from "./store.vue?vue&type=template&id=648982a7&scoped=true&"
import script from "./store.vue?vue&type=script&lang=ts&"
export * from "./store.vue?vue&type=script&lang=ts&"
import style0 from "./store.vue?vue&type=style&index=0&id=648982a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648982a7",
  null
  
)

export default component.exports